var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"colour-selector",style:({
    'border-color': _vm.borderColour,
    background: _vm.backgroundColour
  }),on:{"click":_vm.handleClicked}},[_c('p',{staticClass:"colour-selector__text",style:({ color: _vm.textColour })},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }